import { clsx } from "clsx";

interface ToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  size?: "sm" | "md";
}

export const Toggle = ({ checked, onChange, disabled }: ToggleProps) => {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      disabled={disabled}
      onClick={() => onChange(!checked)}
      className={clsx("tg", checked && "on")}
      style={disabled ? { opacity: 0.5, cursor: "not-allowed" } : undefined}
    />
  );
};

export default Toggle;
